import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash.get'
import pure from 'recompose/pure'
import compose from 'recompose/compose'
import ClassNames from 'classnames'
import translate from '@/i18n/translate'

const TypeField = ({
  source,
  record = {},
  localize,
  translate,
  addLabel,
  sortable,
  locale,
  resource,
  theme,
  ...props
}) => {
  const label = get(record, source)
  return (
    <span {...props} className={ClassNames(theme[`type-${label}`], theme[`type-${source}`])}>
      {localize ? translate(`app.${source}.${label}`) : label}
    </span>
  )
}

TypeField.defaultProps = {
  addLabel: true,
}

TypeField.propTypes = {
  addLabel: PropTypes.bool,
  className: PropTypes.string,
  label: PropTypes.string,
  theme: PropTypes.object.isRequired,
  record: PropTypes.object,
  translate: PropTypes.func.isRequired,
  source: PropTypes.string.isRequired,
}

const enhance = compose(pure, translate)

export default enhance(TypeField)



// WEBPACK FOOTER //
// ./ui/Data/TypeField.js